import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 14"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M2.223 13.067h.134c.11.542.589.933 1.143.933h1.167c.256 0 .466-.21.466-.467v-5.6a.47.47 0 0 0-.466-.466H3.5c-.554 0-1.033.39-1.143.933h-.49V7A6.07 6.07 0 0 1 7.933.933 6.07 6.07 0 0 1 14 7v1.4h-.49a1.17 1.17 0 0 0-1.143-.933H11.2a.47.47 0 0 0-.467.466v5.6c0 .257.21.467.467.467h1.167c.554 0 1.032-.39 1.143-.933h1.073c.706 0 1.284-.578 1.284-1.284v-2.1c0-.571-.38-1.079-.934-1.236V7c0-3.868-3.132-7-7-7s-7 3.132-7 7v1.447A1.28 1.28 0 0 0 0 9.683v2.1c0 .706.578 1.284 1.283 1.284zm1.044-.467V8.633c0-.128.105-.233.233-.233h.7v4.667h-.7a.234.234 0 0 1-.233-.234zM12.6 8.867v3.966a.234.234 0 0 1-.233.234h-.7V8.4h.7c.128 0 .233.105.233.233zm2.333.816v2.1a.35.35 0 0 1-.35.35h-1.05v-2.8h1.05c.193 0 .35.158.35.35m-13.65 2.45a.35.35 0 0 1-.35-.35v-2.1c0-.192.158-.35.35-.35h1.05v2.8z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }